export const accountListFilterState = (searchKey) => ({
  startDate: null,
  endDate: null,
  searchKey: searchKey || "",
  status: "all",
  page: 1,
  perPage: 10,
});
